module.exports = __webpack_public_path__ + "static/media/blogbg.8151fb61.png";